import {Injectable} from '@angular/core';
import {WizardNestedFormService} from '../abstract/wizard-nested-form-service';
import {FormBuilder} from '@angular/forms';
import {WizardValidators} from '../../wizard-validators';
import {takeUntil} from 'rxjs/operators';
import {WizardFormEventsService} from '../wizard-form-events.service';

@Injectable()
export class OrganizationLegalService extends WizardNestedFormService {
    form = this.fb.group({
        _touched: [false, WizardValidators.required()],

        place: ['', [
            WizardValidators.required('Место регистрации организации'),
            WizardValidators.withoutSymbols('недопустимы в месте регистрации'),
        ]],
        date: ['', [
            WizardValidators.required('Дата регистрации юридического лица'),
            WizardValidators.date(),
        ]],
        INN: ['', [
            WizardValidators.required('ИНН юридического лица'),
            WizardValidators.requiredLength(10, 'ИНН юридического лица'),
        ]],
        KPP: ['', [
            WizardValidators.required('КПП юридического лица'),
            WizardValidators.requiredLength(9, 'КПП юридического лица'),
        ]],
        OKPO: ['', [
            WizardValidators.required('ОКПО юридического лица'),
            WizardValidators.requiredLength(8, 'ОКПО юридического лица'),
        ]],
        OGRN: ['', [
            WizardValidators.required('ОГРН юридического лица'),
            WizardValidators.requiredLength(13, 'ОГРН юридического лица'),
        ]],
        OKVED: ['', [
            WizardValidators.required('ОКВЕД'),
        ]],
    });

    constructor(
        private fb: FormBuilder,
        private wizardFormEventsService: WizardFormEventsService,
    ) {
        super();
    }

    init() {
        this.form.get('INN').valueChanges.pipe(
            takeUntil(this.destroyed$)
        ).subscribe((value) => {
            this.wizardFormEventsService.setOrganizationInn(value);
        });
    }
}
